import {
  SALES_RETURN_REPORT,
  EXPENSE_REPORT,
  TAX_REPORT,
  STOCK_REPORT,
  ITEM_SALES_REPORT,
  SALES_PAYMENT_REPORT,
  SALES_REPORT,
  PROFIT_AND_LOSS_REPORT,
  PROCESSOR_REPORT,
  DISPENSARY_REPORT,
  CULTIVATOR_REPORT,
  CASH_DROP_REPORT,
  CASH_FLOAT_REPORT,
  PRODUCT_HISTORICAL_REPORT
} from '@/utils/permissions'

export default [
  {
    path: '/reports/sales-return',
    name: 'sales-return-report',
    component: () => import('@/views/reports/SalesReturnReport.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Sales Return Report',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Sales Return Report', active: true }
      ],
      permissions: [SALES_RETURN_REPORT]
    }
  },
  {
    path: '/reports/expense',
    name: 'expense-report',
    component: () => import('@/views/reports/ExpenseReport.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Expense Report',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Expense Report', active: true }
      ],
      permissions: [EXPENSE_REPORT]
    }
  },
  {
    path: '/reports/tax',
    name: 'tax-report',
    component: () => import('@/views/reports/TaxReport.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Tax Report',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Tax Report', active: true }
      ],
      permissions: [TAX_REPORT]
    }
  },
  {
    path: '/reports/stock',
    name: 'stock-report',
    component: () => import('@/views/reports/StockReport.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Stock Report',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Stock Report', active: true }
      ],
      permissions: [STOCK_REPORT]
    }
  },
  {
    path: '/reports/item-sales',
    name: 'item-sales-report',
    component: () => import('@/views/reports/ItemSalesReport.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Item Sales Report',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Item Sales Report', active: true }
      ],
      permissions: [ITEM_SALES_REPORT]
    }
  },
  {
    path: '/reports/sales-payment',
    name: 'sales-payment-report',
    component: () => import('@/views/reports/SalesPaymentReport.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Sales Payment Report',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Sales Payment Report', active: true }
      ],
      permissions: [SALES_PAYMENT_REPORT]
    }
  },
  {
    path: '/reports/sales',
    name: 'sales-report',
    component: () => import('@/views/reports/SalesReport.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Sales Report',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Sales Report', active: true }
      ],
      permissions: [SALES_REPORT]
    }
  },
  {
    path: '/reports/profit-loss',
    name: 'profit-loss-report',
    component: () => import('@/views/reports/ProfitAndLossReport.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Profit and Loss Report',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Profit and Loss Report', active: true }
      ],
      permissions: [PROFIT_AND_LOSS_REPORT]
    }
  },
  {
    path: '/reports/processor',
    name: 'processor-report',
    component: () => import('@/views/reports/ProcessorReport.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Processor Report',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Processor Report', active: true }
      ],
      permissions: [PROCESSOR_REPORT]
    }
  },
  {
    path: '/reports/dispensary',
    name: 'dispensary-report',
    component: () => import('@/views/reports/DispensaryReport.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Dispensary Report',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Dispensary Report', active: true }
      ],
      permissions: [DISPENSARY_REPORT]
    }
  },
  {
    path: '/reports/cultivator',
    name: 'Cultivator-report',
    component: () => import('@/views/reports/CultivatorReport.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Cultivator Report',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Cultivator Report', active: true }
      ],
      permissions: [CULTIVATOR_REPORT]
    }
  },
  {
    path: '/reports/cash-drop',
    name: 'cash-drop-report',
    component: () => import('@/views/reports/CashDropReport.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Cash Drop Report',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Cash Drop Report', active: true }
      ],
      permissions: [CASH_DROP_REPORT]
    }
  },
  {
    path: '/reports/cash-float',
    name: 'cash-float-report',
    component: () => import('@/views/reports/CashFloatReport.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Open/Close Cash Float Report',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Cash Float Report', active: true }
      ],
      permissions: [CASH_FLOAT_REPORT]
    }
  },

  // product historical report
  {
    path: '/reports/ProductHistorical',
    name: 'product-historical-report',
    component: () => import('@/views/reports/ProductHistoricalReport.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Product Historical Report',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Product Historical Report', active: true }
      ],
      permissions: [PRODUCT_HISTORICAL_REPORT]
    }
  }
]
